import ApiService from '@/services/core/api.service'

const PendingService = {
  async get (query = '') {
    return ApiService.get(`disbursement-associate/check-signing?${query}`)
  },

  async post (payload) {
    return ApiService.post('disbursement-associate/check-signing', payload)
  },

  async put (payload) {
    return ApiService.put(`disbursement-associate/check-signing/${payload.id}`, payload)
  },

  async delete (payload) {
    return ApiService.delete(`disbursement-associate/check-signing/${payload.id}`)
  }
}

export default PendingService
